import { Link } from 'react-router-dom';
import LegalPage, { LegalSection, company } from './LegalPage';
import { useLocale } from '../../context/LocaleContext';
import { privacyAr } from '../../i18n/legalAr';

const Privacy = () => {
  const { lang } = useLocale();
  if (lang === 'ar') {
    return (
      <LegalPage title={privacyAr.title} intro={privacyAr.intro}>
        {privacyAr.sections.map((section) => (
          <LegalSection key={section.id} id={section.id} title={section.title}>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.id === 'rights' && (
              <p>
                <Link to="/terms" className="text-purple-700 hover:underline">شروط العملاء</Link>
              </p>
            )}
          </LegalSection>
        ))}
      </LegalPage>
    );
  }

  return (
  <LegalPage
    title="Privacy policy"
    intro={`This is the privacy policy of ${company.product}. ${company.product} is operated by ${company.name}, the company, at ${company.address}. It explains what ${company.product} collects when you browse events, create an account, or buy a ticket.`}
  >
    <LegalSection id="who" title="1. Who is responsible">
      <p>
        {company.product} is the service. {company.name}, the company at {company.address}, is responsible for the personal data {company.product} holds. Company website:{' '}
        <a href={company.site} target="_blank" rel="noopener noreferrer" className="text-purple-700 hover:underline">{company.siteLabel}</a>.
        Phone and WhatsApp: {company.phone}.
      </p>
    </LegalSection>

    <LegalSection id="data" title="2. Data we collect">
      <p>Account details you submit: name, email, password, and mobile number if you add one.</p>
      <p>Order details: events, ticket categories, quantities, the amount paid, and a payment reference from the payment provider. We do not store full card numbers on Ticketaty servers.</p>
      <p>Technical data: browser type, device, and pages viewed, used to keep the site working and to understand which pages fail.</p>
    </LegalSection>

    <LegalSection id="use" title="3. How we use it">
      <p>We use this data to create your account, take payment, issue tickets, send the ticket to you, and tell you if an event is changed or cancelled.</p>
      <p>We also use it to prevent fraud, to answer a support request, and to meet record-keeping duties that apply to {company.name} as the company operating {company.product}.</p>
    </LegalSection>

    <LegalSection id="sharing" title="4. Who we share it with">
      <p>The Organizer of an event you buy receives the information they need to admit you, such as your name, ticket reference, and the category you bought.</p>
      <p>Payment providers receive the details required to take or refund a payment. Hosting and email providers process data only so Ticketaty can run.</p>
      <p>
        Organizers who want staffing or photo storage use separate products. Talent bookings are referred to{' '}
        <a href="https://talencia.io" target="_blank" rel="noopener noreferrer" className="text-purple-700 hover:underline">Talencia</a>.
        Storing and sharing photos securely with face recognition is referred to{' '}
        <a href="https://camup.ai" target="_blank" rel="noopener noreferrer" className="text-purple-700 hover:underline">CamupAI</a>.
        Those services apply their own terms. Buying a Ticketaty ticket does not by itself enroll you in face recognition.
      </p>
    </LegalSection>

    <LegalSection id="cookies" title="5. Cookies">
      <p>
        Ticketaty uses cookies and similar storage that are needed to keep you signed in, to remember a queue or checkout step, and to protect the form from abuse. You can block cookies in your browser. Parts of checkout may then stop working.
      </p>
    </LegalSection>

    <LegalSection id="retention" title="6. How long we keep it">
      <p>
        We keep account and order records for as long as your account is open and for the period we need to handle refunds, disputes, and accounting. Technical logs are kept for a shorter period.
      </p>
    </LegalSection>

    <LegalSection id="rights" title="7. Your choices">
      <p>
        You may ask us what account data we hold, ask for a correction, or ask us to close your account. We may keep an order record where we still need it for a payment dispute or a legal duty.
      </p>
      <p>
        Write to {company.product} at {company.name}, {company.address}, or call {company.phone}. See also the{' '}
        <Link to="/terms" className="text-purple-700 hover:underline">customer terms</Link>.
      </p>
    </LegalSection>
  </LegalPage>
  );
};

export default Privacy;
